import { useEffect, useState } from "react"
import { useFirestore } from "react-redux-firebase"

export default function useAddressForm({ auth, notify, toggle, addressId }) {
  const initialValues = {
    name: "",
    addressLine1: "",
    addressLine2: "",
    city: "",
    state: "",
    zipCode: "",
  }
  const [values, setValues] = useState(initialValues)
  const setValue = (key, value) => setValues({ ...values, [key]: value })
  const firestore = useFirestore()

  const setAddress = async () => {
    if (addressId) {
      let customerRef = firestore.collection("customers").doc(auth.uid)
      const address = await customerRef
        .collection("address")
        .doc(addressId)
        .get()
      setValues({ ...address?.data() })
    }
  }

  useEffect(() => {
    setAddress()
  }, [addressId])

  const handleSubmit = async () => {
    try {
      let customerRef = firestore.collection("customers").doc(auth.uid)
      if (addressId) {
        customerRef.collection("address").doc(addressId).update(values)
      } else {
        await customerRef.collection("address").add(values)
      }
      const message = `Address ${addressId ? "update" : "added"} successfully.`
      notify("success", message, "Success")
    } catch (error) {
      const message =
        error?.message ||
        `Error while ${addressId ? "updating" : "adding"} address`
      console.log(error)
      notify("error", message, "Error")
    } finally {
      toggle()
    }
  }

  return {
    values,
    setValue,
    handleSubmit,
  }
}
